import { globalProperties } from '@/main'
import * as maRequests from '@/base/ma-requests'

import { MaNotification } from '@mobileaction/action-kit'

export function useMaCore() {
  const analytics = globalProperties.$analytics
  const maNotification = MaNotification

  return {
    maRequests,
    analytics,
    maNotification,
  }
}
